<div class="fw-bold my-3">Add Checkpoint</div>
<div class="row row-cols-1 row-cols-lg-2">
  <div class="col">
    <form [formGroup]="checkPointForm">
      @if (currentStep === 1) {
        <div class="row row-cols-2 gy-2 mb-4">
          <div class="col">
            <button
              type="button"
              class="btn btn-secondary btn-lg w-100"
              [routerLink]="['/checkpoints']"
            >
              Cancel
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-primary w-100"
              [disabled]="!checkPointForm.valid"
              (click)="currentStep = 2"
            >
              Next
            </button>
          </div>
        </div>

        <div class="d-flex flex-column gap-2 mb-3">
          <div class="flex-grow-1">
            <gtapp-input-field
              dtValue="Checkpoint Name"
              inputId="cpName"
              [maxLength]="100"
              [inputStringValue]="checkPointForm.value.name"
              (blurEmit)="
                checkPointForm.controls['name'].setValue($event);
                checkPointForm.value?.site_id ? null : shiftFocus('siteId')
              "
            >
            </gtapp-input-field>
          </div>
          <div class="flex-grow-1">
            @if (checkPointForm.value.site_id) {
              <dl class="p-2">
                <dt>Site</dt>
                <dd class="link-edit" (click)="editField('site')">
                  {{ checkPointForm.value.site }}
                  [{{ checkPointForm.value.company }}]
                  <div class="small text-secondary">
                    {{ selectedSite?.address?.full_address }}
                  </div>
                </dd>
              </dl>
            } @else {
              <div>
                <gtapp-auto-complete
                  [data]="siteListData"
                  placeHolder="Site (where this checkpoint belongs)"
                  searchKeyword="company_name"
                  [initialValue]="checkPointForm.value.site"
                  [itemTemplate]="siteTemplate"
                  [addInitialKey]="true"
                  (inputChanged)="onSiteSearch($event)"
                  (selected)="onSiteSelect($event)"
                  inputId="siteId"
                  [enableCloseOption]="true"
                  (fieldCleared)="editField('site')"
                >
                </gtapp-auto-complete>
              </div>
              <ng-template #siteTemplate let-item>
                @if (item?.key === 0) {
                  <div>Create New Site</div>
                } @else {
                  <div>
                    <div class="fw-medium">
                      {{ item?.company_name }} [{{
                        item?.company?.company_name
                      }}]
                    </div>
                    <div class="small-font text-secondary">
                      {{ item?.address?.full_address }}
                    </div>
                  </div>
                }
              </ng-template>
            }
          </div>
          @if (latLon) {
            <div class="flex-grow-1">
              <gtapp-address-lookup
                [addressForm]="checkPointForm"
                (updateAddress)="addressSelected($event)"
                [editSelectedAddress]="!isCheckpointFormValid && showMap"
                showLookupFrom="addCheckpoint"
                (lookupNewAddress)="$event ? (showMap = false) : null"
              >
              </gtapp-address-lookup>
            </div>
          }
        </div>
        @if (showMap && latLon && !largeView) {
          <div class="mt-2">
            <gtapp-map-leaflet
              [latLon]="latLon"
              mapId="smallMapIdAddCheckpoint"
              [changableRadius]="true"
              [cursorDraggable]="true"
              (emitData)="emitData($event)"
              (updateMinDistance)="updateMinDistance($event)"
            ></gtapp-map-leaflet>
            <div class="text-center small">
              <em> Drag the marker to set coordinates </em>
            </div>
          </div>
        }
      }
      @if (currentStep === 2) {
        <div class="row row-cols-2 mb-4">
          <div class="col">
            <!-- enter key on cleint select calling these buttons. Added type to avoid that-->
            <button
              type="button"
              class="btn btn-secondary btn-lg w-100"
              (click)="currentStep = 1; goBack()"
            >
              Back
            </button>
          </div>

          <div class="col">
            <!-- enter key on cleint select calling these buttons. Added type to avoid that-->
            <button
              type="button"
              class="btn btn-success btn-lg w-100"
              [disabled]="!checkPointForm.valid || addBtnPressed"
              (click)="onClickSubmit()"
            >
              Add Checkpoint
            </button>
          </div>
        </div>
        <div class="d-flex flex-wrap gap-3 mb-3">
          <div class="flex-grow-1">
            <gtapp-input-field
              dtValue="Description (Optional)"
              inputId="description"
              [maxLength]="500"
              [inputStringValue]="checkPointForm.value.description"
              (blurEmit)="
                checkPointForm.controls['description'].setValue($event)
              "
            >
            </gtapp-input-field>
          </div>
        </div>
        @if (userPromptsTotalCount) {
          <span>Assign Post Scan Mobile Form</span>
          @if (userPromptsTotalCount > 7) {
            <gtapp-auto-complete
              [data]="userPromptsSearchResults"
              placeHolder="Select Mobile Form"
              searchKeyword="name"
              [itemTemplate]="userPromptLookupTemplate"
              (inputChanged)="searchPrompts($event)"
              (selected)="addRemoveUserPrompt($event)"
            >
            </gtapp-auto-complete>
            <ng-template #userPromptLookupTemplate let-item>
              <div>{{ item?.name }}</div>
            </ng-template>
          }

          <table class="table table-borderless">
            <tbody cdkDropList (cdkDropListDropped)="dropUserPrompt($event)">
              @for (
                prompt of availableUserPrompts;
                track prompt;
                let i = $index
              ) {
                <tr
                  cdkDrag
                  [cdkDragDisabled]="!prompt.selected"
                  class="cursor-pointer"
                  [ngClass]="prompt.selected ? 'cursor-move' : ''"
                  (click)="addRemoveUserPrompt(prompt)"
                >
                  <td>
                    <div class="d-flex align-items-center">
                      @if (prompt.selected && selectedUserPrompts?.length > 1) {
                        <span class="me-2">
                          <i class="fa-solid fa-bars"></i>
                        </span>
                      }

                      @if (prompt.selected) {
                        <div class="pe-2">{{ i + 1 }}.</div>
                      }

                      <div
                        role="button"
                        class="p-2 border rounded bg-secondary-subtle text-dark"
                        [ngClass]="
                          prompt.selected ? 'fw-semibold' : 'opacity-75'
                        "
                      >
                        <i class="fa-solid fa-clipboard-list text-success"></i>
                        <span class="small ms-1">{{ prompt?.name }}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>

          @if (
            userPromptsTotalPages > 1 &&
            userPromptsTotalCount != availableUserPrompts?.length
          ) {
            <div class="mt-3">
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                (click)="onLoadMore()"
              >
                Load More
              </button>
            </div>
          }
        }
      }
    </form>
  </div>

  <div class="col">
    @if (showMap && latLon && largeView) {
      <div>
        <gtapp-map-leaflet
          [latLon]="latLon"
          mapId="addCpLargeMap"
          [changableRadius]="true"
          [cursorDraggable]="true"
          (emitData)="emitData($event)"
          (updateMinDistance)="updateMinDistance($event)"
        ></gtapp-map-leaflet>
        <div class="text-center small">
          <em> Drag the marker to set coordinates </em>
        </div>
      </div>
    }
  </div>
</div>
